import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { routerShape } from 'react-router';
import Icon from '../../components/Icon';
import CollegeEventsFilterPreview from '../../components/CollegeEventsFilterPreview';
import './styles.css';

const messages = defineMessages({
  header: {
    id: 'collegeevents.filter.matches.header',
    defaultMessage: 'RECOMMENDED TO',
  },
  students: {
    id: 'collegeevents.filter.matches.students',
    defaultMessage: 'students',
  },
  broad: {
    id: 'collegeevents.filter.matches.broad',
    defaultMessage: 'Large Audience:',
  },
  reconfigure: {
    id: 'collegeevents.filter.matches.reconfigure',
    // eslint-disable-next-line max-len
    defaultMessage: 'The audience for this filter is at least 10,000 students, we suggest reconfiguring to reduce the size of the audience.',
  },
  previewMsg: {
    id: 'collegeevents.filter.matches.preview-msg',
    defaultMessage: 'As you build your filter, a summary of your selection will display here.',
  },
});

class CollegeEventFilterMatches extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    filter: PropTypes.object,
    hideSummary: PropTypes.bool,
    router: routerShape,
  };

  constructor(props) {
    super(props);
    this.state = { matches: (props.viewer || {}).eventMatchCountByFilter || 0 };
  }

  render() {
    const { matches } = this.state;
    return (
      <div data-cy="filter-matches-component" styleName="filter-matches-container">
        {(matches > 9999) && (
          <div styleName="too-broad">
            <Icon styleName="broad-icon" name="exclamation circle" />
            <span styleName="broad"><FormattedMessage {...messages.broad} /></span>
            <span><FormattedMessage {...messages.reconfigure} /></span>
          </div>
        )}
        <div styleName="filter-matches">
          <div styleName="filter-matches-inner">
            <div><FormattedMessage {...messages.header} /></div>
            <div styleName="match-count">{matches}</div>
            <div><FormattedMessage {...messages.students} /></div>
          </div>
          {!this.props.hideSummary &&
            (
              <div styleName="preview" data-cy="filter-summary">
                <CollegeEventsFilterPreview
                  {...this.props.filter}
                  emptyMessage={<p styleName="preview-msg"><FormattedMessage {...messages.previewMsg} /></p>}
                />
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default CollegeEventFilterMatches;
